import styled, { css } from 'styled-components'

export const PayPage = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, #f7f3ef 0%, #ebe4dc 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 12px 24px;
  box-sizing: border-box;
`

export const LangBar = styled.div`
  position: absolute;
  top: 10px;
  inset-inline-end: 10px;
  z-index: 1;
`

export const LangBtn = styled.button`
  min-width: 36px;
  height: 28px;
  padding: 0 8px;
  border-radius: 8px;
  border: none;
  background: #f3eee9;
  color: #422303;
  font-size: 12px;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(66, 35, 3, 0.08);

  &:hover {
    background: #ebe4dc;
  }
`

export const StatusBanner = styled.div`
  text-align: center;
  padding: 16px 16px 8px;

  svg {
    width: 48px;
    height: 48px;
    margin-bottom: 6px;
  }

  .title {
    font-size: 15px;
    font-weight: 700;
  }

  .hint {
    margin-top: 6px;
    font-size: 11px;
    color: #8a7a6a;
  }

  ${({ success }) =>
    success
      ? css`color: #07b558;`
      : css`color: #9e0823;`
  }
`

export const StatusVal = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: ${({ success }) => (success ? '#07b558' : '#9e0823')};
`

export const BillCard = styled.div`
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 6px 24px rgba(66, 35, 3, 0.1);
  overflow: hidden;
  position: relative;
`

export const BillHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px 16px 12px;
  border-bottom: 1px dashed #e8e0d8;
`

export const LogoCircle = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: #fff;
  border: none;
  box-shadow:
    0 4px 14px rgba(66, 35, 3, 0.14),
    0 1px 3px rgba(66, 35, 3, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin-bottom: 10px;
  padding: 8px;
  box-sizing: border-box;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`

export const LogoPlaceholder = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: #f3eee9;
  border: none;
  box-shadow:
    0 4px 14px rgba(66, 35, 3, 0.14),
    0 1px 3px rgba(66, 35, 3, 0.08);
  margin-bottom: 10px;
`

export const BillTitle = styled.h1`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #422303;
  line-height: 1.35;
  word-break: break-word;
`

export const BillBody = styled.div`
  padding: 0 16px;
`

export const DetailRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #f3eee9;

  &:last-child {
    border-bottom: none;
  }
`

export const DetailTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #6b5b4b;
`

export const DetailVal = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #404040;
  text-align: end;
  word-break: break-all;
`

export const AmountBlock = styled.div`
  margin: 10px 16px 4px;
  padding: 10px 12px;
  background: #faf7f4;
  border-radius: 10px;
  text-align: center;

  .label {
    font-size: 11px;
    color: #8a7a6a;
    margin-bottom: 2px;
  }

  .value {
    font-size: 24px;
    font-weight: 700;
    color: ${({ theme }) => theme?.colors?.primaryButtCol || '#9c5a2e'};
    letter-spacing: 0.02em;
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 6px;
  }

  .currency {
    font-size: 13px;
    font-weight: 600;
    opacity: 0.85;
  }
`

export const MethodsSection = styled.div`
  padding: 4px 16px 0;
`

export const MethodsTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #422303;
  margin-bottom: 6px;
`

export const MethodsList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
`

export const MethodItem = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 100%;
  min-height: 52px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1.5px solid #ebe4dc;
  background: #fff;
  cursor: pointer;
  text-align: start;
  font-family: inherit;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;

  ${({ active, theme }) =>
    active
      ? css`
          border-color: ${theme?.colors?.primaryButtCol || '#9c5a2e'};
          background: #faf7f4;
          box-shadow: 0 0 0 1px ${theme?.colors?.primaryButtCol || '#9c5a2e'};
        `
      : css`
          &:hover {
            border-color: #d4c4b4;
          }
        `}
`

export const MethodIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: ${({ $brand }) => ($brand ? '56px' : '40px')};
  min-height: ${({ $brand }) => ($brand ? '32px' : '26px')};
  flex-shrink: 0;

  img {
    height: ${({ $brand }) => ($brand ? '30px' : '22px')};
    width: auto;
    max-width: ${({ $brand }) => ($brand ? '72px' : '48px')};
    object-fit: contain;
  }
`

export const MethodName = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #404040;
  line-height: 1.25;
`

export const ApplePayWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  /* Native Apple Pay button — leave empty; system draws the logo */
  .apple-pay-button,
  #applePayment,
  #apple-pay-btn {
    display: inline-block;
    width: 100%;
    height: 48px;
    min-height: 48px;
    border: 0;
    border-radius: 8px;
    cursor: pointer;
    padding: 0;
    margin: 0;
    overflow: hidden;
    background-image: -webkit-named-image(apple-pay-logo-white);
    background-size: 100% 60%;
    background-repeat: no-repeat;
    background-position: center;
    background-color: #000;
    -webkit-appearance: -apple-pay-button;
    -apple-pay-button-type: plain;
    -apple-pay-button-style: black;
  }

  .hint {
    font-size: 11px;
    color: #8a7a6a;
    text-align: center;
  }
`

/** Hesabe google-pay.js mounts into #googlePaybtn / #container */
export const GooglePayWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 8px 0 0;

  #googlePaybtn {
    width: 100%;
    min-height: 48px;
  }

  #container {
    width: 100%;
    min-height: 48px;
  }

  #container > * {
    width: 100% !important;
  }

  .hint {
    font-size: 11px;
    color: #8a7a6a;
    text-align: center;
  }
`

export const DirectCardWrap = styled.div`
  margin: 8px 16px 0;
  padding: 12px;
  border: 1px solid #ebe4dc;
  border-radius: 10px;
  background: #faf7f4;

  .title {
    font-size: 13px;
    font-weight: 700;
    color: #422303;
    margin-bottom: 10px;
  }

  #payment-container {
    min-height: 320px;
    width: 100%;
  }

  #payment-container iframe,
  #hesabe-payments,
  #hesabe-payments iframe {
    width: 100% !important;
    min-height: 420px;
    border: 0;
    border-radius: 8px;
    background: #fff;
  }

  #hesabe-payments {
    min-height: 420px;
  }
`

export const BillFooter = styled.div`
  padding: 12px 16px 16px;
`

export const CompanyCard = styled.div`
  width: 100%;
  max-width: 400px;
  margin-top: 12px;
  padding: 12px 14px;
  text-align: center;
  color: #6b5b4b;
`

export const CompanyName = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #422303;
  margin-bottom: 4px;
`

export const CompanyLine = styled.div`
  font-size: 11px;
  line-height: 1.45;
  color: #8a7a6a;

  a {
    color: #8a7a6a;
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme?.colors?.primaryButtCol || '#9c5a2e'};
    }
  }
`

export const ErrorCard = styled.div`
  width: 100%;
  max-width: 400px;
  background: #ffffff;
  border-radius: 14px;
  padding: 24px 16px;
  text-align: center;
  color: #9e0823;
  font-weight: 600;
  box-shadow: 0 6px 24px rgba(66, 35, 3, 0.1);
`
